/** The Home Portal house glyph — the corporate mark, the one SVG that is not a Lucide icon. */
export function BrandMark({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 34.04 39.423"
      className={className}
      style={style}
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
    >
      <path d="M23.854,28.863,30.5,35.507V14.989L23.854,18Z" transform="translate(3.535 2.221)" />
      <path d="M0,35.515l6.64-6.641V18.005L0,14.969Z" transform="translate(0 2.218)" />
      <path d="M15.7,0,.785,14.972l6.64,3.035L15.7,9.7Z" transform="translate(.116 0)" />
      <path d="M15.86,0V9.7l8.282,8.311L30.8,14.987Z" transform="translate(2.35 0)" />
      <path d="M8.12,28.547,1.472,35.193H32.127l-6.643-6.646Z" transform="translate(.218 4.23)" />
    </svg>
  );
}
